"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _SetAssignmentModalTitle = _interopRequireDefault(require("../../../contexts/SetAssignmentModalTitle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SubscriptionBlockContent = /*#__PURE__*/function (_Component) {
  _inherits(SubscriptionBlockContent, _Component);

  function SubscriptionBlockContent(props) {
    var _this;

    _classCallCheck(this, SubscriptionBlockContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubscriptionBlockContent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onBackClick", function () {
      var onBackClick = _this.props.onBackClick;

      if (!onBackClick) {
        return;
      }

      _this.setState(function (_ref) {
        var defaultModalTitle = _ref.defaultModalTitle;
        return {
          modalTitle: defaultModalTitle
        };
      });

      onBackClick();
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var onSave = _this.props.onSave;

      _this.setState(function (_ref2) {
        var defaultModalTitle = _ref2.defaultModalTitle;
        return {
          modalTitle: defaultModalTitle
        };
      });

      onSave();
    });

    _defineProperty(_assertThisInitialized(_this), "getDescription", function () {
      var _this$props = _this.props,
          assignmentType = _this$props.assignmentType,
          assignedDescriptions = _this$props.assignedDescriptions;

      if (!assignedDescriptions || !assignedDescriptions.length) {
        return "Cannot find any ".concat(assignmentType, " assigned to this Organisation Account.");
      }

      return assignedDescriptions;
    });

    _defineProperty(_assertThisInitialized(_this), "setModalTitle", function (title) {
      _this.setState({
        modalTitle: title
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      var _this$props2 = _this.props,
          onToggleModal = _this$props2.onToggleModal,
          onCloseModal = _this$props2.onCloseModal;

      if (onCloseModal) {
        return void onCloseModal();
      }

      _this.setState(function (_ref3) {
        var assigningItem = _ref3.assigningItem;
        return {
          assigningItem: !assigningItem
        };
      }, function () {
        if (!onToggleModal) {
          return;
        }

        var assigningItem = _this.state.assigningItem;
        onToggleModal({
          closed: !assigningItem
        });
      });
    });

    _this.setModalTitle = _this.setModalTitle.bind(_assertThisInitialized(_this));

    var _defaultModalTitle = "Assign ".concat(props.assignmentType);

    _this.state = {
      assigningItem: false,
      // https://github.com/yannickcr/eslint-plugin-react/issues/1697

      /* eslint-disable-next-line react/no-unused-state */
      defaultModalTitle: _defaultModalTitle,
      modalTitle: _defaultModalTitle
    };
    return _this;
  }

  _createClass(SubscriptionBlockContent, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          assigningItem = _this$state.assigningItem,
          modalTitle = _this$state.modalTitle;
      var _this$props3 = this.props,
          assignmentType = _this$props3.assignmentType,
          assignedName = _this$props3.assignedName,
          assignmentModalContent = _this$props3.assignmentModalContent,
          modalSaveDisabled = _this$props3.modalSaveDisabled,
          customModalTitle = _this$props3.customModalTitle,
          saveBtnText = _this$props3.saveBtnText,
          closeBtnText = _this$props3.closeBtnText,
          onBackClick = _this$props3.onBackClick,
          stayOpenOnSave = _this$props3.stayOpenOnSave,
          disabled = _this$props3.disabled;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.FormModal, {
        key: "".concat(assignmentType, "-modal"),
        visible: assigningItem,
        onClose: this.toggleModal,
        title: customModalTitle || modalTitle,
        onSave: this.onSave,
        saveText: saveBtnText,
        closeText: closeBtnText,
        showBackBtn: Boolean(onBackClick),
        onBackClick: this.onBackClick,
        stayOpenOnSave: stayOpenOnSave,
        saveDisabled: modalSaveDisabled
      }, _react.default.createElement(_SetAssignmentModalTitle.default.Provider, {
        value: this.setModalTitle
      }, assignmentModalContent)), _react.default.createElement(_commonReact.Form.FormBlockDescription, {
        key: "subscription-block-desc",
        description: this.getDescription(),
        name: assignedName || "NO ".concat(assignmentType, " FOUND"),
        buttonText: assignedName ? 'MODIFY' : 'ASSIGN',
        onClickButton: this.toggleModal,
        highlightedName: true,
        hideButton: disabled
      }));
    }
  }]);

  return SubscriptionBlockContent;
}(_react.Component);

exports.default = SubscriptionBlockContent;

_defineProperty(SubscriptionBlockContent, "defaultProps", {
  saveBtnText: 'Save Changes'
});